import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { JobListRecommendationsInterestsResponse } from '@doda/api-client/aspida/@types/index';
import { LOADING_STATUS } from '@doda/common/src/constants/loadingStatus';
import { FetchBaseStateType } from '@doda/common/src/interfaces/fetchBaseState';
import { getInterestsJobList } from './services/fetchIntentionJobList';

type IntentionJobListEntityType =
  FetchBaseStateType<JobListRecommendationsInterestsResponse | null>;

/**
 * 初期型
 */
export interface IntentionJobListState {
  intentionJobList: IntentionJobListEntityType;
}

export const intentionJobListInitialState: IntentionJobListState = {
  intentionJobList: {
    loading: LOADING_STATUS.IDLE,
    entity: null,
  },
};

const intentionJobListSlice = createSlice({
  name: 'intentionJobList',
  initialState: intentionJobListInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getInterestsJobList.pending, (state) => {
      state.intentionJobList.loading = LOADING_STATUS.PENDING;
    });
    builder.addCase(
      getInterestsJobList.fulfilled,
      (
        state,
        action: PayloadAction<JobListRecommendationsInterestsResponse>
      ) => {
        state.intentionJobList.loading = LOADING_STATUS.SUCCESS;
        state.intentionJobList.entity = action.payload;
      }
    );
    builder.addCase(getInterestsJobList.rejected, (state) => {
      state.intentionJobList.loading = LOADING_STATUS.ERROR;
    });
  },
});

// Reducer
export const intentionJobListReducer = intentionJobListSlice.reducer;

interface State {
  intentionJobList: IntentionJobListState;
}

// Selector
/**
 * intentionJobListEntitySelector
 * @param state
 * @returns 求人一覧
 */
export const intentionJobListEntitySelector = <S extends State>(state: S) => {
  return state.intentionJobList.intentionJobList.entity;
};

/**
 * intentionJobHasVideoSelector
 * @param state
 * @returns 動画求人が含まれているかの判定
 */
export const intentionJobHasVideoSelector = <S extends State>(state: S) => {
  return state.intentionJobList.intentionJobList.entity?.results?.some(
    ({ movieId }) => Boolean(movieId)
  );
};
